module.exports = __webpack_public_path__ + "static/6-f53b3be5e4a46f01adab8b370990d85b.png";